/**
 *  Tv - channels plugin or system module implementation
 */

'use strict';

var Emitter = require('cjs-emitter');

module.exports = {
    // onAppInit: require('./stalker'),
    onAppInit: function ( config, callback ) {
        var appPlugin = require('./stalker');

        appPlugin(config, callback);

    },
    onInit: require('./daemon.stalker'),
    onContentBoardInit: function ( dump, done ) {
        require('./leanback')(dump.api, done);
    }
};
